import React from "react";
import "./notification.css";
import { useNavigate } from "react-router-dom";

const Notification = ({ icon, count, to }) => {
  const navigate = useNavigate();

  return (
    <div className="notification" onClick={() => navigate(to)}>
      <img src={icon} alt="notification icon" />
      {count > 0 && <span>{count}</span>}
    </div>
  );
};

export default Notification;
